module.exports = __webpack_public_path__ + "img/lineup05@2x.29327cbd.png";